<template>
  <v-app v-if="this.auth==1" id="inspire">
    <v-dialog persistent v-model="altpwd" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Alterar password</span>
        </v-card-title>
        <v-form ref="form">
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <label class="label-modal">Password</label>
                  <v-text-field color="#969462" type="password" v-model="pwd"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <label class="label-modal">Confirmar password</label>
                  <v-text-field color="#969462" type="password" v-model="cpwd" :rules="pwdRules"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#969462" flat @click.native="altpwd=false">Cancelar</v-btn>
            <v-btn color="#969462" flat @click.native="changeData">Guardar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="termos" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Termos e Condições</span>
        </v-card-title>
        <v-form ref="form">
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12 v-html="getTermos"></v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#969462" flat @click.native="logout">Não Aceitar</v-btn>
            <v-btn color="#969462" flat @click.native="setTermosChecked">Aceitar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-navigation-drawer
      v-if="$route.name != 'relatorio'"
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      fixed
      app
    >
      <v-list dense>
        <template v-for="(item, index) in items">
          <v-list-tile
            v-if="(item.super==0) || (item.super == 1 && getSession.user.super == 1) || (item.super == 2 && getSession.user.super == 0)"
            :key="index"
            :to="item.to"
          >
            <v-list-tile-action class="pm-text">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="pm-text">
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      v-if="$route.name != 'relatorio'"
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="#969462"
      dark
      app
      fixed
    >
      <v-toolbar-title style="width: 280px" class="ml-0 pl-3">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <span class="hidden-sm-and-down">Enes & Araújo</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <span class="wlcTxt">Bem-vindo, {{getSession.user.nome}}</span>
      <span class="divi">|</span>
      <v-btn v-on:click.stop="altpwd=true" icon>
        <v-icon>settings</v-icon>
      </v-btn>
      <v-btn v-on:click.stop="logout" icon>
        <v-icon>power_settings_new</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <v-container
        fluid
        fill-height
        v-bind:style="$route.name == 'relatorio' ? 'padding: 0 !important' : ''"
      >
        <v-layout>
          <router-view></router-view>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
  <Login v-else-if="this.auth==0 && this.$route.name != 'relatorio'" />
  <Relatorio v-else-if="this.auth==0 && this.$route.name == 'relatorio'" />
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import JWT from "jsonwebtoken";

import { sendNotification } from "./store/fcm";

import { PRIVATE, PUBLIC } from "./store/variables";

export default {
  data: () => ({
    auth: -1,
    drawer: null,
    termos: false,
    items: [
      {
        icon: "home",
        super: 0,
        text: "Home",
        to: "/"
      },
      {
        icon: "receipt",
        super: 0,
        text: "Extratos de Conta",
        to: "/extratos"
      },
      {
        icon: "insert_chart",
        super: 0,
        text: "Balancetes Analíticos",
        to: "/balanceteanalitico"
      },
      {
        icon: "insert_chart_outlined",
        super: 0,
        text: "Balancetes Razão",
        to: "/balanceterazao"
      },
      {
        icon: "folder",
        super: 0,
        text: "Documentos",
        to: "/documentos"
      },
      {
        icon: "class",
        super: 2,
        text: "Relatórios gestão - Nova versão",
        to: "/relatoriosgestao"
      },
      {
        icon: "cloud_upload",
        super: 2,
        text: "Uploads",
        to: "/uploads"
      },
      //{ icon: "class", super: 0, text: "Relatórios", to: "/relatorios" },
      {
        icon: "warning",
        super: 1,
        text: "Informações relevantes",
        to: "/informacoes"
      },
      {
        icon: "notification_important",
        super: 1,
        text: "Notificações",
        to: "/notificacoes"
      },
      {
        icon: "people_outline",
        super: 1,
        text: "Clientes",
        to: "/clientes"
      },
      {
        icon: "business",
        super: 1,
        text: "Escritórios",
        to: "/escritorios"
      },
      {
        icon: "assignment",
        super: 1,
        text: "Termos e condições",
        to: "/termos"
      },
      {
        icon: "group_add",
        super: 1,
        text: "Utilizadores",
        to: "/utilizadores"
      }
    ],
    altpwd: false,
    email: "",
    pwd: "",
    cpwd: "",
    defaultRules: null,
    pwdRules: null
  }),
  computed: {
    ...mapGetters({
      getSession: "session/getState",
      getTermos: "termos/getTermos",
      IsReady: "termos/IsReady"
    })
  },
  watch: {
    getState(val) {
      //if(val) this.auth=1;
    },
    altpwd(val) {
      this.pwd = "";
      this.cpwd = "";
    }
  },
  created() {
    this.pwdRules = [
      v => v == this.pwd || "* As palavras-passe não coincidem!"
    ];

    this.ManageSession();

    this.$eventBus.$on("login", res => {
      if (res) {
        this.SessionStart();
      }
    });

    /* this.$eventBus.$on("relatorio", codigo => {
           if (codigo) {
             let routeData = this.$router.resolve({name: 'relatorio', query: {cliente: codigo, ano: "2019", mes: "03"}});
             window.open(routeData.href, '_blank');
           }
         }); */

    this.$eventBus.$on("sendNotification", params => {
      sendNotification(params).then(res => {
        if (res) this.toast("success", "Notificação enviada com sucesso!");
        else this.toast("error", "Não foi possível enviar a notificação!");
      });
    });

    this.$eventBus.$on("logout", () => {
      this.logout();
    });
  },
  methods: {
    setTermosChecked() {
      if (this.getSession.user.super == 1) return;

      this.$store
        .dispatch(
          "utilizadores/setTermosChecked",
          this.getSession.user.id_utilizador
        )
        .then(res => {
          if (res) this.termos = false;
        });
    },

    changeData() {
      if (this.pwd && this.pwd == this.cpwd)
        this.$store
          .dispatch("session/update", {
            id: this.getSession.user.id_utilizador,
            password: this.pwd
          })
          .then(res => {
            if (res) {
              this.toast("success", "Password alterada com sucesso!");
              this.altpwd = false;
            } else {
              this.toast("error", "Ocorreu um erro ao alterar a password!");
              this.altpwd = false;
            }
          });
    },
    toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      } else {
        return iziToast.show({
          title: "ERRO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      }
    },

    ManageSession() {
      if (!this.$session.exists()) this.auth = 0;
      else {
        this.decode(this.$cookies.get("t")).then(res => {
          this.$store
            .dispatch("session/getData", {
              email: res
            })
            .then(() => {
              if (this.getSession.session) {
                this.SessionStart();
              } else this.auth = 0;
            });
        });
      }
    },

    SessionStart() {
      this.$session.start();
      this.$cookies.config("3d");
      this.$cookies.set("t", this.token(this.getSession.user.email));
      this.OpenStore();
    },
    async OpenStore() {
      this.$store.dispatch("termos/get");

      if (this.getSession.user.super == 1) this.$store.dispatch("avisos/get");
      else this.$store.dispatch("avisos/getByEscritorio");

      if (this.getSession.user.super == 1)
        this.$store.dispatch("notificacoes/get");
      else this.$store.dispatch("notificacoes/getByUser");

      if (this.getSession.user.super == 1)
        this.$store.dispatch("utilizadores/get");

      if (this.getSession.user.super == 0)
        this.$store.dispatch("documentos/get");
      //else this.$store.dispatch("documentos/getAllUsers");

      if (this.getSession.user.super == 1)
        this.$store.dispatch("escritorios/get");

      this.auth = 1;

      setTimeout(() => {
        if (
          this.IsReady &&
          this.getSession.user.super == 0 &&
          this.getSession.user.termos == 0
        )
          this.termos = true;
      }, 1500);

      this.$eventBus.$emit("loader", false);
    },
    logout() {
      this.$store.dispatch("session/setSessionData", null).then(() => {
        this.auth = 0;
        this.$session.destroy();
        setTimeout(() => {
          location.reload();
        }, 500);
      });
    },
    token(params) {
      return JWT.sign(
        {
          exp: Math.floor(Date.now() / 1000) + 60 * 60 * 12,
          data: params
        },
        process.env.SECRET
      );
    },
    decode(token) {
      return new Promise(function(resolve, reject) {
        JWT.verify(token, process.env.SECRET, (err, decoded) => {
          if (err) resolve(false);
          else resolve(JWT.decode(token).data);
        });
      });
    }
  }
};
</script>

<style>
.application {
  font-family: "Roboto", sans-serif !important;
}

.theme--light.application {
  background: #f8f8f8 !important;
}

.container {
  margin: 0 !important;
}

#report canvas {
  width: 100% !important;
  height: 35vh !important;
}

table .v-menu__activator {
  display: flex !important;
  justify-content: flex-end !important;
}

.pm-text {
  color: #5d5d5d !important;
}

.v-list__tile--active > div {
  color: #969462 !important;
}

canvas {
  width: 100% !important;
}

.v-table .error {
  background-color: white !important;
  color: rgba(0, 0, 0, 0.3) !important;
}

.searchTable {
  width: 25% !important;
  float: right !important;
  padding-bottom: 10px !important;
  margin-right: 10px !important;
}

.v-table tr {
  cursor: pointer !important;
}

.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
  background-color: #eee !important;
}

.tableHeader {
  padding: 10px !important;
  background-color: white !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.textTable {
  justify-content: center !important;
}

.textRight {
  text-align: right !important;
}

.textLeft {
  text-align: left !important;
}

.textCenter {
  text-align: center !important;
}

.label-modal {
  font-size: 11px !important;
  color: #c4c4c4 !important;
  text-transform: uppercase !important;
}

.theme--light.v-subheader {
  color: #969462 !important;
}

.v-subheader--inset {
  margin: 0 !important;
}

.v-subheader {
  padding: 0 !important;
}

.iziToast-wrapper-topRight {
  margin-top: 50px !important;
}

.v-tabs__slider-wrapper {
  height: 10px !important;
  width: 146px !important;
}

.v-card__actions {
  margin-top: -40px !important;
}

.noTableHeader {
  background-color: #fff !important;
  height: 58px !important;
}

.tableTitle {
  position: absolute;
  margin: 25px;
  color: #969462;
  font-size: 19px;
  font-weight: 400;
}

.settings-switch {
  flex: none !important;
}

.divi {
  font-size: 25px !important;
  font-weight: 400 !important;
  margin-right: 10px !important;
}

.headline {
  margin-left: 20px !important;
  margin-bottom: -30px !important;
  color: #969462 !important;
}

.deleteModal {
  margin-left: 0px !important;
}

.actions-delete {
  margin-top: 0px !important;
}

.menu-ativo div,
.menu-ativo i {
  color: #969462 !important;
  caret-color: #969462 !important;
}

.v-btn-toggle--selected {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.1), 0 2px 2px 0 rgba(0, 0, 0, 0.05),
    0 1px 5px 0 rgba(0, 0, 0, 0) !important;
}

.wlcTxt {
  font-size: 15px !important;
  margin-right: 25px !important;
  text-transform: uppercase !important;
}

.formulario .v-input--selection-controls {
  margin-top: 0px !important;
}

.formulario .v-input__slot {
  margin-bottom: 0px !important;
}

.avisos .v-expansion-panel {
  box-shadow: none !important;
}

.avisos .theme--light.v-expansion-panel .v-expansion-panel__container,
.avisos .v-card {
  background-color: #f8f8f8 !important;
}

.avisos .v-expansion-panel__header {
  padding: 0 16px 0 16px !important;
}

.avisos .v-expansion-panel__container {
  margin-bottom: 5px !important;
}

.v-toolbar__items a {
  color: #fff !important;
  margin-right: 20px !important;
}

.v-expansion-panel
  .aviso-border
  .v-expansion-panel__header
  .v-expansion-panel__header__icon
  i {
  color: #4caf50 !important;
}

.aviso-warning {
  color: #4caf50 !important;
}

.v-expansion-panel .aviso-border {
  border: 1px solid #4caf50 !important;
}

.v-expansion-panel
  .aviso-border-grey
  .v-expansion-panel__header
  .v-expansion-panel__header__icon
  i {
  color: #9e9e9e !important;
}

.aviso-warning-grey {
  color: #333333 !important;
}

.v-expansion-panel .aviso-border-grey {
  border: 1px solid #9e9e9e !important;
}

#P2 .menuable__content__active {
  min-width: none;
  width: 100% !important;
}

.v-small-dialog__actions .v-btn {
  color: #969462 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue